import React, { useEffect, useState } from 'react';
import client from '../api/client';

const empty = { name_ar: '', name_en: '', location: '', start_date: '', end_date: '', registration_deadline: '', status: 'open' };

export default function Events() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty);

  const load = () => client.get('/events').then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    await client.post('/events', form);
    setForm(empty);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('تأكيد الحذف؟')) return;
    await client.delete(`/events/${id}`);
    load();
  };

  return (
    <div className="grid grid-2">
      <div className="card">
        <h3 style={{ marginTop: 0 }}>إضافة فعالية</h3>
        <form onSubmit={submit}>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>اسم الفعالية (عربي) *</label>
            <input value={form.name_ar} onChange={e => setForm({ ...form, name_ar: e.target.value })} required />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الموقع</label>
            <input value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>تاريخ البداية</label>
            <input type="date" value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>تاريخ النهاية</label>
            <input type="date" value={form.end_date} onChange={e => setForm({ ...form, end_date: e.target.value })} />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>آخر موعد للتسجيل</label>
            <input type="date" value={form.registration_deadline} onChange={e => setForm({ ...form, registration_deadline: e.target.value })} />
          </div>
          <button className="btn btn-primary">إضافة</button>
        </form>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>الفعاليات ({rows.length})</h3>
        <table>
          <thead><tr><th>الاسم</th><th>البداية</th><th>النهاية</th><th></th></tr></thead>
          <tbody>
            {rows.map(ev => (
              <tr key={ev.id}>
                <td>{ev.name_ar}</td><td>{ev.start_date}</td><td>{ev.end_date}</td>
                <td><button className="btn btn-danger" onClick={() => remove(ev.id)}>حذف</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
